export function autocompleteFilterOption(
  inputValue: string,
  option: { value: string } | undefined
): boolean {
  return !!option?.value.toLowerCase().includes(inputValue.toLowerCase())
}
